<template>
  <client-only>
    <template v-if="isOpen">
      <div class="backdrop"></div>
      <div class="modal-container">
        <h4>{{ $t("bnpl:cookie_modal.title") }}</h4>
        <p>
          {{ $t("bnpl:cookie_modal.description") }}
        </p>
        <a :href="$t('bnpl:cookie_modal.link.href')">{{ $t("bnpl:cookie_modal.link.text") }}</a>
        <div class="flex-row gap8 buttons">
          <button id="bnpl_cookie_deny_button" class="light" @click="denyCookies">
            {{ $t("bnpl:cookie_modal.button.reject") }}
          </button>
          <button id="bnpl_cookie_accept_button" @click="acceptCookies">
            {{ $t("bnpl:cookie_modal.button.accept_all") }}
          </button>
        </div>
      </div>
    </template>
  </client-only>
</template>
<script setup>
import { loadTrackingScripts, setBarionConsent } from "~/utils/tracking";

const isOpen = ref(true);

const denyCookies = () => {
  isOpen.value = false;
  localStorage.setItem("cookie:accepted", false);
  setBarionConsent(false);
};
const acceptCookies = () => {
  isOpen.value = false;
  localStorage.setItem("cookie:accepted", true);
  loadTrackingScripts();
};

const getCookieSetting = () => {
  return localStorage.getItem("cookie:accepted");
};

onBeforeMount(() => {
  isOpen.value = !getCookieSetting();
});
</script>
<style scoped lang="scss">
.backdrop {
  display: none;
}
.modal-container {
  background-color: white;
  background-image: url("~/assets/svg/cookie.svg");
  background-position: calc(100% + 10px) calc(0% - 10px);
  background-repeat: no-repeat;
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 8px;
  bottom: 32px;
  right: 64px;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  font-size: 14px;

  height: max-content;
  width: fit-content;
  max-width: 400px;

  z-index: 100;

  h4 {
    margin: 0;
  }

  div {
    height: min-content;
  }

  button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    margin: 0;
    flex: 1;

    border-radius: 8px;
    border: none;
    background: var(--brandPrimary);
    color: white;

    font-size: 16px;
    line-height: 100%;
    font-weight: 500;

    cursor: pointer;

    &:hover {
      background: var(--brandPrimaryDark);
    }

    &.light {
      background: var(--brandPrimaryLight);
      color: var(--brandPrimary);

      &:hover {
        border: 1px solid var(--brandPrimaryDark);
        color: var(--brandPrimaryDark);
        padding: 11px 15px;
      }
    }
  }

  svg {
    position: absolute;
    top: 0;
    right: 0;
  }

  a {
    color: var(--gray600);
    text-decoration: underline;
    padding-bottom: 8px;
  }
}

@media only screen and (max-width: 792px) {
  .backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 99;
    background: rgba($color: #000000, $alpha: 0.5);
  }
  .modal-container {
    // display: flex;
    inset: unset;
    left: 0;
    right: 0;
    top: 50%;
    transform: translate(0%, -50%);
    margin: 32px;

    button {
      font-size: 14px;
    }
  }
}

@media only screen and (max-width: 400px) {
  .modal-container {
    div.buttons {
      flex-direction: column;
    }
  }
}
</style>
